export default __webpack_public_path__ + "static/media/gallery_06.b56efef5.jpg";